<template>
  <div class="page">
    <div class="container">
      <div class="header">
        <img
          class="back"
          @click="handleBackClick"
          src="@/assets/wordTest/back-2.png"
          alt=""
        />
        <div class="header-title">
          {{ reportData?.bookName }} {{ reportData?.frameworkName }}
          <!-- <img class="change" src="@/assets/wordTest/change.png" alt=""> -->
        </div>
        <div @click="handleFreeLearning" class="header-title-right">
          自由学习
        </div>
      </div>
      <div class="content">
        <div class="content-layoyt">
          <div class="left">
            <img class="funnel-t" src="@/assets/wordTest/funnel-t.png" alt="" />
            <div class="funnel-img-wrap">
              <img
                class="funnel-img"
                :src="
                  reportData?.thirdlyReport
                    ? require('@/assets/wordTest/funnel-3.png')
                    : reportData?.secondReport
                    ? require('@/assets/wordTest/funnel-2.png')
                    : require('@/assets/wordTest/funnel-1.png')
                "
                alt=""
              />
              <div v-if="reportData?.firstReport">
                {{ reportData?.firstReport?.errorCount }}个
              </div>
              <div v-if="reportData?.secondReport">
                {{ reportData?.secondReport?.errorCount }}个
              </div>
              <div v-if="reportData?.thirdlyReport">
                {{ reportData?.thirdlyReport?.errorCount }}个
              </div>
            </div>
          </div>
          <div class="right">
            <div class="title-wrapper">
              <img
                class="title-line"
                src="@/assets/wordTest/list-l.png"
                alt=""
              />
              <span class="title-text">单词测验明细表</span>
              <img
                class="title-line"
                src="@/assets/wordTest/list-r.png"
                alt=""
              />
            </div>
            <div class="table-wrap">
              <table class="table" style="width: 96%">
                <thead>
                  <tr class="table-header">
                    <th style="width: 25%">单词列表</th>
                    <th style="width: 25%">第一轮</th>
                    <th style="width: 25%">第二轮</th>
                    <th style="width: 25%">第三轮</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="table-content-wrap">
              <!-- 第二轮未开始图标：显示在第一行 -->
              <img
                v-if="!reportData?.secondReport && reportData?.firstReport?.wordInfoList?.length > 0"
                class="empty-img-center empty-img-second"
                src="@/assets/wordTest/no-start.png"
                alt=""
              />
              <!-- 第三轮未开始图标：显示在第一行 -->
              <img
                v-if="!reportData?.thirdlyReport && reportData?.firstReport?.wordInfoList?.length > 0"
                class="empty-img-center empty-img-third"
                src="@/assets/wordTest/no-start.png"
                alt=""
              />
              <table class="table-body-wrap">
                <tbody class="table-content">
                  <!-- 保留你原有的业务逻辑 -->
                  <tr
                    v-for="(item, index) in reportData?.firstReport
                      ?.wordInfoList"
                    :key="item.wordId"
                  >
                    <td style="width: 25%">
                      <div class="word-name">{{ item.name }}</div>
                    </td>
                    <!-- 第一轮 -->
                    <td style="width: 25%">
                      <!-- 第一轮：仅当该轮数据存在时才渲染图标 -->
                      <template v-if="item">
                        <div class="td-child">
                          <!-- 对错图标 -->
                          <img
                            class="re-icon"
                            :src="
                              item.passStatus === 1
                                ? require('@/assets/quick/right.png')
                                : require('@/assets/quick/error.png')
                            "
                            alt=""
                          />
                          <!-- 情绪图标 -->
                          <img
                            class="hs-icon"
                            :src="
                              item.passStatus === 1
                                ? require('@/assets/wordTest/happy.png')
                                : require('@/assets/wordTest/sad.png')
                            "
                            alt=""
                          />
                        </div>
                      </template>
                      <!-- 数据缺失时显示占位 -->
                      <span
                        class="empty-cell"
                        v-else-if="
                          reportData?.firstReport?.wordInfoList?.[index]
                            ?.passStatus === ''
                        "
                        >--</span
                      >
                      <img
                        v-else-if="
                          index ===
                            reportData?.firstReport?.wordInfoList.length / 2 &&
                          !reportData?.firstReport
                        "
                        class="empty-img"
                        src="@/assets/wordTest/no-start.png"
                        alt=""
                      />
                    </td>
                    <!-- 第二轮  -->
                    <td style="width: 25%">
                      <div class="td-child">
                        <!-- 第二轮已开始：查找匹配的单词 -->
                        <template v-if="reportData?.secondReport">
                          <template
                            v-for="secondWord in reportData.secondReport
                              .wordInfoList"
                            :key="secondWord.wordId"
                          >
                            <template v-if="secondWord.wordId === item.wordId">
                              <img
                                v-if="secondWord.passStatus === 1"
                                class="re-icon"
                                src="@/assets/quick/right.png"
                                alt=""
                              />
                              <img
                                v-else
                                class="re-icon"
                                src="@/assets/quick/error.png"
                                alt=""
                              />
                              <img
                                v-if="secondWord.passStatus === 1"
                                class="hs-icon"
                                src="@/assets/wordTest/happy.png"
                                alt=""
                              />
                              <img
                                v-else
                                class="hs-icon"
                                src="@/assets/wordTest/sad.png"
                                alt=""
                              />
                            </template>
                          </template>
                          <!-- 第二轮已开始但该单词不存在：显示占位 -->
                          <span
                            v-if="
                              reportData.secondReport.wordInfoList &&
                              !reportData.secondReport.wordInfoList.find(
                                (w) => w.wordId === item.wordId
                              )
                            "
                            class="empty-cell"
                            >--</span
                          >
                        </template>
                      </div>
                    </td>
                    <!-- 第三轮-->
                    <td style="width: 25%">
                      <div class="td-child">
                        <!-- 第三轮已开始：查找匹配的单词 -->
                        <template v-if="reportData?.thirdlyReport">
                          <template
                            v-for="thirdWord in reportData.thirdlyReport
                              .wordInfoList"
                            :key="thirdWord.wordId"
                          >
                            <template v-if="thirdWord.wordId === item.wordId">
                              <img
                                v-if="thirdWord.passStatus === 1"
                                class="re-icon"
                                src="@/assets/quick/right.png"
                                alt=""
                              />
                              <img
                                v-else
                                class="re-icon"
                                src="@/assets/quick/error.png"
                                alt=""
                              />
                              <img
                                v-if="thirdWord.passStatus === 1"
                                class="hs-icon"
                                src="@/assets/wordTest/happy.png"
                                alt=""
                              />
                              <img
                                v-else
                                class="hs-icon"
                                src="@/assets/wordTest/sad.png"
                                alt=""
                              />
                            </template>
                          </template>
                          <!-- 第三轮已开始但该单词不存在：显示占位 -->
                          <span
                            v-if="
                              reportData.thirdlyReport.wordInfoList &&
                              !reportData.thirdlyReport.wordInfoList.find(
                                (w) => w.wordId === item.wordId
                              )
                            "
                            class="empty-cell"
                            >--</span
                          >
                        </template>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="content-bottom-layout">
          <div class="left">
            <div class="ip-content">
              <img class="ip" src="@/assets/wordTest/ip-2.png" alt="" />
              <div class="ip-text">
                {{ calcEfficiency(round) }}
              </div>
            </div>
            <div class="words-info">
              <div class="words-info-item">
                共 {{ reportData?.totalWord }} 个单词
              </div>
              <div class="words-info-item">
                <div class="words-info-item-content">
                  <span>{{ reportData?.mastered }}</span>
                  <div>已掌握</div>
                </div>
                <div class="words-info-item-content">
                  <span>{{
                    reportData?.totalWord - reportData?.mastered
                  }}</span>
                  <div>未掌握</div>
                </div>
              </div>
            </div>
          </div>
          <div class="right" v-show="isShowProgress">
            <!-- 进度 -->
            <div class="progress">
              <div class="progress-child">
                <!-- 答过一轮的高亮-->
                <!-- 第一轮全对就不用显示二三轮了 -以此类推 -->
                <div class="step">
                  <div>
                    <img :src="require('@/assets/wordTest/1-a.png')" alt="" />
                    <img
                      v-if="!isFirstPass"
                      class="next-icon"
                      src="@/assets/wordTest/n-a.png"
                      alt=""
                    />
                  </div>
                  <!-- 第一轮全对 或 第二轮已有数据：显示通过率；否则且第二轮无数据：显示“去测试” -->
                  <div class="step-text">
                    第一轮通过率：<span class="pass">{{
                      reportData?.firstReport?.rightCount
                    }}</span
                    >/{{ reportData?.firstReport?.totalCount }}
                  </div>
                 
                </div>
                <div class="step" v-if="!isFirstPass">
                  <div>
                    <img
                      :src="
                        reportData?.secondReport
                          ? require('@/assets/wordTest/2-a.png')
                          : require('@/assets/wordTest/two.png')
                      "
                      alt=""
                    />
                    <img
                      v-if="!isSecondPass"
                      class="next-icon"
                      :src="
                        reportData?.secondReport ||
                        (!reportData?.secondReport &&
                          reportData?.secondStudyStatus === 2)
                          ? require('@/assets/wordTest/n-a.png')
                          : require('@/assets/wordTest/next-disabled.png')
                      "
                      alt=""
                    />
                  </div>
                  <!-- 第二轮有数据：显示通过率 -->
                  <div
                    class="step-text"
                    v-if="
                      isSecondPass ||
                      reportData?.thirdlyReport ||
                      reportData?.secondReport
                    "
                  >
                    第二轮通过率：
                    <span class="pass">{{
                      reportData?.secondReport?.rightCount
                    }}</span
                    >/{{ reportData?.secondReport?.totalCount }}
                  </div>
                  <!-- 第二轮没数据：显示“去测试” -->
                  <div
                    @click="goTest(reportData?.secondStudyStatus, 2)"
                    v-else-if="
                      reportData?.firstReport &&
                      !reportData?.secondReport &&
                      [0, 1, 2].includes(reportData?.secondStudyStatus)
                    "
                    :class="[
                      'step-text-box',
                      { active: reportData?.secondStudyStatus === 2 },
                    ]"
                  >
                    去测试
                  </div>
                  <div v-else class="no-start">未开始</div>
                </div>
                <div class="step" v-if="!isSecondPass && !isFirstPass">
                  <div>
                    <img
                      :src="
                        reportData?.thirdlyReport ||
                        (!reportData?.thirdlyReport &&
                          reportData?.thirdlyStudyStatus === 2)
                          ? require('@/assets/wordTest/3-a.png')
                          : require('@/assets/wordTest/three.png')
                      "
                      alt=""
                    />
                  </div>
                  <!-- 第三轮有数据：显示通过率 -->
                  <div class="step-text" v-if="reportData?.thirdlyReport">
                    第三轮通过率：<span class="pass">
                      {{ reportData?.thirdlyReport?.rightCount }}</span
                    >/{{ reportData?.thirdlyReport?.totalCount }}
                  </div>
                  <!-- 第三轮没数据 && 第二轮有数据：显示“去测试” -->
                  <div
                    @click="goTest(reportData?.thirdlyStudyStatus, 3)"
                    v-else-if="
                      [0, 1, 2].includes(reportData?.thirdlyStudyStatus) &&
                      reportData?.secondReport &&
                      !reportData?.thirdlyReport
                    "
                    :class="[
                      'step-text-box',
                      { active: reportData?.thirdlyStudyStatus === 2 },
                    ]"
                  >
                    去测试
                  </div>
                  <div v-else class="no-start">未开始</div>
                </div>
              </div>
            </div>
            <div class="bottom-btn-wrap">
              <!-- 答对的数量跟总单词一致 -->
              <!-- <div @click="recheckPopup.show(bookInfo)">test</div> -->
              <div
                v-if="
                  round === 3 || reportData?.totalWord === reportData?.mastered
                "
              >
                <div
                  class="bottom-btn again"
                  @click="recheckPopup.show(bookInfo)"
                >
                  重新测验
                </div>
                <div class="bottom-btn free" @click="handleFreeLearning">
                  自由学习
                </div>
              </div>
              <div v-else class="bottom-btn funnel" @click="goFunnel">
                漏斗式学习
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RecheckPopup ref="recheckPopup" @success="handleBackClick"></RecheckPopup>
    <audio ref="audioRef" preload="auto"></audio>
  </div>
</template>
<script>
export default {
  name: "WordTestData",
};
</script>
<script setup>
import {
  ref,
  computed,
  nextTick,
  onActivated,
  onMounted,
  onBeforeUnmount,
  watch,
} from "vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { getReportSummary, freeLearning } from "@/api/quick";
import RecheckPopup from "./components/Recheck-popup.vue";
import { showToast } from "vant";
import noMastered from "@/assets/audio/not-mastered.mp3";
import mastered from "@/assets/audio/mastered.mp3";
// 音频播放
const audioRef = ref(null);
function playAudio(url) {
  const audioUrl =
    reportData.value?.totalWord === reportData.value?.mastered
      ? mastered
      : noMastered;
  nextTick(() => {
    audioRef.value.src = audioUrl;
    audioRef.value.play();
  });
}
// 关闭所有音频
function closeAllAudio() {
  nextTick(() => {
    audioRef.value.pause();
  });
}
const route = useRoute();
const router = useRouter();
// 返回按钮点击事件
const handleBackClick = () => {
  closeAllAudio();
  const quitRequest = JSON.stringify({
    func: "getDialogDismiss",
  });
  if (window.android) {
    window.android.callNative(quitRequest);
  }
};
const token = ref("");
function callJS(data) {
  let parsed;
  try {
    parsed = typeof data === 'string' ? JSON.parse(data) : data;
  } catch (error) {
    console.error('callJS 解析失败:', error);
    return;
  }
  
  const { func, params } = parsed;
  
  // 如果是 getToken 或 getPageUrl，全局 callJS 已经处理了，这里不重复处理
  if (func === 'getToken' || func === 'getPageUrl') {
    return;
  }
  
  // 处理页面特定的逻辑
  if (func === "refresh") {
    console.log("🔄 收到刷新消息，重新加载数据");
    reloadData();
  }
  if (func === "actOnDestroy") {
    // 关闭所有音频
    closeAllAudio();
  }
}
function goToken() {
  // 先调用全局 getToken（如果存在），确保 token 和 host 已获取
  if (window.getToken) {
    window.getToken();
  }
  
  // 从 localStorage 读取 token
  const savedToken = localStorage.getItem('token');
  if (savedToken) {
    token.value = savedToken;
    getReport();
  }
}

// 调用原生 getShowBg 函数
function getShowBg() {
  const getShowBgRequest = JSON.stringify({
    func: "getShowBg",
    params: {
      fromType: 1
    }
  });
  if (window.android) {
    window.android.callNative(getShowBgRequest);
  }
}
const reportData = ref({});
// const firstReport = {
// 			wordInfoList: [
// 				{ wordId: 1, name: 'apple',  passStatus: 1 },
// 				{ wordId: 2, name: 'banana', passStatus: 0 },
// 				{ wordId: 3, name: 'cat',    passStatus: 1 },
// 				{ wordId: 4, name: 'dog',    passStatus: 1 },
// 				{ wordId: 5, name: 'egg',    passStatus: 0 },
// 				{ wordId: 6, name: 'fish',   passStatus: 1 },
// 			]
// 		}
// 			const secondReport = {
// 			wordInfoList: [
// 				{ wordId: 1, name: 'apple',  passStatus: 1 },
// 				{ wordId: 2, name: 'banana', passStatus: 0 },
// 				{ wordId: 3, name: 'cat',    passStatus: 1 },
// 				{ wordId: 4, name: 'dog',    passStatus: 1 },
// 				{ wordId: 5, name: 'egg',    passStatus: 0 },
// 				{ wordId: 6, name: 'fish',   passStatus: 1 },
// 			]
// 		}
// 		// 模拟第三轮数据
// 		const thirdlyReport = {
// 			wordInfoList: [
// 							{ wordId: 7, name: 'goat',   passStatus: 0 },
// 				{ wordId: 8, name: 'hat',    passStatus: 1 },
// 				{ wordId: 9, name: 'ice',    passStatus: 1 },
// 				{ wordId: 10, name: 'jump',  passStatus: 0 },

// 				]
// 		}
// 		// 将模拟数据合并到 reportData
// 		reportData.value.firstReport = firstReport
// 		reportData.value.secondReport = secondReport
// 		reportData.value.thirdlyReport  = thirdlyReport
const calcEfficiency = (finishedRound) => {
  const { totalWord, firstReport, secondReport, thirdlyReport } =
    reportData.value || {};
  // 核心：第一轮结束，直接返回「暂无数据」（无论是否有总单词数）
  if (finishedRound === 1) {
    return "暂无数据";
  }
  // 无总单词数（非第一轮场景）→ 返回 0%
  if (!totalWord || totalWord === 0) {
    return "学习效率:0%";
  }
  // 按轮次累加正确数
  let totalRight = 0;
  if (finishedRound >= 1) totalRight += firstReport?.rightCount || 0; // 第一轮必加（第二轮及以上）
  if (finishedRound >= 2) totalRight += secondReport?.rightCount || 0; // 第二轮及以上加
  if (finishedRound >= 3) totalRight += thirdlyReport?.rightCount || 0; // 第三轮加
  // 计算百分比并取整，拼接%
  const efficiency = Math.round((totalRight / totalWord) * 100);
  return `学习效率:${efficiency}%`;
};
const isShowProgress = ref(false);
const round = ref(null);
async function getReport() {
  const res = await getReportSummary({
    bookId: bookInfo.value.bookId,
    frameworkId: bookInfo.value.frameworkId,
  });
  if (res.code === 200) {
    console.log(res.data);
    reportData.value = res.data;
    // reportData.value.thirdlyStudyStatus = 2
    const curData = res.data;
    // 根据已完成的轮次映射到后端学习界面类型（3-阶段一，4-阶段二，5-阶段三）
    const { firstReport, secondReport, thirdlyReport } = curData || {};
    round.value =
      firstReport && !secondReport ? 1 : secondReport && !thirdlyReport ? 2 : 3;
    currentRound.value = round.value == 1 ? 3 : round.value == 2 ? 4 : 5;
    isShowProgress.value = true;
    playAudio();
  }
}
// 第一轮全对
const isFirstPass = computed(() => {
  return (
    reportData.value?.firstReport?.rightCount ===
    reportData.value?.firstReport?.totalCount
  );
});
// 第二轮全对
const isSecondPass = computed(() => {
  // 只有当 secondReport 存在时，才比较 rightCount 和 totalCount
  if (!reportData.value?.secondReport) return false;
  return (
    reportData.value.secondReport.rightCount ===
    reportData.value.secondReport.totalCount
  );
});
/* eslint-disable */
// 第三轮全对
const isThirdPass = computed(() => {
  // 只有当 thirdlyReport 存在时，才比较 rightCount 和 totalCount
  if (!reportData.value?.thirdlyReport) return false;
  return (
    reportData.value.thirdlyReport.rightCount ===
    reportData.value.thirdlyReport.totalCount
  );
});
// 跳转单词学习
function goWordLearning(type) {
  // 关闭音频
  closeAllAudio();
  const wordLearningRequest = JSON.stringify({
    func: "getGoLearnWords",
    params: {
      sourceType: type || currentRound.value,
      bookId: bookInfo.value.bookId,
      frameworkId: bookInfo.value.frameworkId,
    },
  });
  if (window.android) {
    window.android.callNative(wordLearningRequest);
  }
}
async function handleFreeLearning() {
  const res = await freeLearning({
    bookId: bookInfo.value.bookId,
    frameworkId: bookInfo.value.frameworkId,
  });
  if (res.code === 200) {
    goWordLearning("0"); //0就是自由学习
  }
}
// 去测试
function goTest(status, round) {
  // round: 1=第一轮, 2=第二轮, 3=第三轮
  // sourceType: 3=第一阶段, 4=第二阶段, 5=第三阶段
  console.log(status, round, reportData.value, "status, round");
  if (status === 0 || status === 1) {
    showToast({
      message: "完成学习后，才可进行下一轮测试哦",
      duration: 1200,
    });
    return;
  }

  let sourceType = null;

  if (round === 2) {
    sourceType = 4;
  } else if (round === 3) {
    sourceType = 5;
  }

  // if (!sourceType) {
  // 	showToast({
  // 		message: '当前状态不符合测试条件',
  // 		duration: 1200,
  // 	})
  // 	return;
  // }
  console.log(sourceType, "sourceType",8888);
  router.push({
    path: "/quickQA/index",
    query: {
      bookId: bookInfo.value.bookId,
      frameworkId: bookInfo.value.frameworkId,
      sourceType: round,
    },
  });
}
// 漏斗式学习
// 当前轮次
const currentRound = ref(null); //3阶段一 4阶段二 5阶段三
function goFunnel() {
  goWordLearning();
}
const recheckPopup = ref(null);
const bookInfo = ref({});
// 标记是否已经初始化
const isInitialized = ref(false);
// 标记是否正在加载数据，避免重复加载
const isLoading = ref(false);

// 重新加载数据的统一方法
const reloadData = async () => {
  // 如果正在加载，跳过
  if (isLoading.value) {
    console.log("数据正在加载中，跳过重复加载");
    return;
  }

  // 检查必要的参数
  if (!bookInfo.value.bookId || !bookInfo.value.frameworkId) {
    console.log("缺少必要参数，无法加载数据");
    return;
  }

  // 如果没有 token，先获取 token
  if (!token.value) {
    console.log("Token 不存在，先获取 Token");
    goToken();
    return;
  }

  try {
    isLoading.value = true;
    console.log("🔄 重新加载数据...");
    await getReport();
  } catch (error) {
    console.error("重新加载数据失败:", error);
  } finally {
    isLoading.value = false;
  }
};

// 监听页面可见性变化（当页面从后台切回前台时）
let visibilityChangeHandler = null;

onMounted(() => {
  if (route.query.bookId) {
    bookInfo.value = {
      bookId: route.query.bookId,
      frameworkId: route.query.frameworkId,
    };
  }
  // 保存原有的 callJS（全局的）
  const originalCallJS = window.callJS;
  window.callJS = (data) => {
    // 先调用全局 callJS（处理 getToken 和 getPageUrl）
    if (originalCallJS) {
      originalCallJS(data);
    }
    // 然后调用页面特定的 callJS（只处理页面特定的逻辑，getToken 和 getPageUrl 会被跳过）
    callJS(data);
  };
  
  // 从 localStorage 读取 token
  const savedToken = localStorage.getItem('token');
  if (savedToken) {
    token.value = savedToken;
  }
  
  // 请求页面特定的数据（会先调用全局 getToken）
  goToken();
  // 调用 getShowBg
  getShowBg();
  isInitialized.value = true;

  // 监听页面可见性变化（类似 uniapp 的 onShow）
  visibilityChangeHandler = () => {
    if (document.visibilityState === "visible") {
      console.log("📱 页面变为可见（visibilitychange），重新加载数据");
      // 页面从隐藏变为可见时，重新加载数据
      if (isInitialized.value) {
        reloadData();
      }
    }
  };
  document.addEventListener("visibilitychange", visibilityChangeHandler);
});

// onActivated: 当页面被 keep-alive 缓存后，再次激活时调用（类似 uniapp 的 onShow）
onActivated(() => {
  console.log("📱 页面激活（onActivated），重新加载数据");
  // 如果已经初始化过，重新加载数据
  if (isInitialized.value) {
    reloadData();
  }
});

// 监听路由变化，当路由参数变化时重新加载
watch(
  () => route.query,
  (newQuery, oldQuery) => {
    // 如果 bookId 或 frameworkId 发生变化，更新 bookInfo 并重新加载
    if (
      newQuery.bookId !== oldQuery?.bookId ||
      newQuery.frameworkId !== oldQuery?.frameworkId
    ) {
      console.log("🔄 路由参数变化，更新数据");
      if (newQuery.bookId && newQuery.frameworkId) {
        bookInfo.value = {
          bookId: newQuery.bookId,
          frameworkId: newQuery.frameworkId,
        };
        reloadData();
      }
    }
  },
  { immediate: false }
);

onBeforeUnmount(() => {
  // 清理事件监听器
  if (visibilityChangeHandler) {
    document.removeEventListener("visibilitychange", visibilityChangeHandler);
  }
});
</script>
<style scoped lang="scss">
/* eslint-disable-next-line no-mixed-spaces-and-tabs */
.page {
  width: 960px;
  height: 600px;
  .container {
    width: 100%;
    height: 100%;
    // background-image: url("@/assets/wordTest/bg-2.png");
    // background-size: cover;
    // background-repeat: no-repeat;
	background: transparent;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .header {
      padding: 0 20px; // 内容区域保持左右 padding
      position: relative;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      .header-title {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        .change {
          width: 17px;
          height: 17px;
          margin-left: 5px;
        }
      }
      .header-title-right {
        background-image: url("@/assets/wordTest/r-bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        width: 106px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 14px;
        color: #7e94c2;
        padding-left: 24px;
        box-sizing: border-box;
      }
      .back {
        width: 39px;
        height: 39px;
      }
    }
    .content {
      flex: 1;
      position: relative;
      padding-bottom: 86px;
      padding: 0px 20px 86px 20px;
      box-sizing: border-box;
      .content-layoyt {
        width: 100%;
        height: 100%;
        background: linear-gradient(
          180deg,
          #e8fdff 0%,
          #ffffff 20%,
          #ffffff 100%
        );
        border-radius: 50px 50px 0px 0px;
        display: flex;
        gap: 16px;
        .left {
          flex: 0 0 40%;
          padding-top: 70px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          .funnel-t {
            width: 246px;
            height: 26px;
          }
          .funnel-img {
            width: 286px;
            height: 250px;
          }
          /* 绝对定位的文字层 */
          .funnel-img-wrap {
            position: relative;
            font-weight: bold;
            font-size: 16px;
            color: #ffffff;
          }
          .funnel-img-wrap > div {
            position: absolute;
            color: #fff;
            font-weight: bold;
            text-align: center;
            transform: translateX(-50%); /* 水平居中 */
            white-space: nowrap;
          }

          /* 第一层：顶部 */
          .funnel-img-wrap > div:nth-child(2) {
            top: 40%; /* 根据图片比例调整 */
            left: 50%;
            transform: translateX(-50%);
          }

          /* 第二层：中间 */
          .funnel-img-wrap > div:nth-child(3) {
            top: 63%;
            left: 50%;
            transform: translateX(-50%);
          }

          /* 第三层：底部 */
          .funnel-img-wrap > div:nth-child(4) {
            top: 81%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .right {
          flex: 1;
          display: flex;
          flex-direction: column;
          .title-wrapper {
            text-align: center;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            padding: 14px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            .title-text {
              margin: 0 5px;
            }
            .title-line {
              width: 89px;
              height: 8px;
            }
          }
          .table-wrap {
            .table {
              border-radius: 24px 24px 0px 0px;
              overflow: hidden;
              padding: 0;
              border-spacing: 0;
              .table-header {
                border-radius: 24px 24px 0px 0px;
                height: 45px;
                background: #e6f2ff;
                font-weight: bold;
                font-size: 14px;
                color: #75a7ff;
              }
            }
          }
          .table-content-wrap {
            width: 96%;
            min-height: 310px;
            max-height: 310px;
            overflow-y: auto;
            position: relative;
            /* 自定义滚动条整体样式 */
            &::-webkit-scrollbar {
              width: 6px;
            }
            /* 自定义滚动条滑块 */
            &::-webkit-scrollbar-thumb {
              background: #d6e0eb;
              border-radius: 3px;
            }
            /* 自定义滚动条轨道 */
            &::-webkit-scrollbar-track {
              background: transparent;
            }
            .empty-img-center {
              position: absolute;
              width: 52px;
              height: 52px;
              transform: translate(-50%, -50%);
              z-index: 999;
              top: 22.5px; /* 第一行的中心位置（45px / 2） */
            }
            .empty-img-second {
              left: calc(96% * 0.65);
            }
            .empty-img-third {
              left: calc(96% * 0.91);
            }
            .table-body-wrap {
              width: 100%;
              border: 1px solid #e6f2ff;
              border-bottom-left-radius: 24px;
              border-bottom-right-radius: 24px;
              border-spacing: 0;
            }
            .table-content {
              .word-name {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                max-width: 150px;
              }
              tr:last-child td {
                border-bottom: none;
              }
              .empty-cell {
                color: #a2acbf;
              }
              td {
                height: 45px;
                border-bottom: 1px solid #e6f2ff;
                text-align: center;
                font-size: 15px;
                color: #333333;
                .td-child {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  .empty-img {
                    position: absolute;
                    top: -50px;
                    left: 50%;
                    width: 52px;
                    height: 52px;
                    transform: translate(-50%,50%);
                  }
                }
                .re-icon {
                  width: 17px;
                  height: 17px;
                }
                .hs-icon {
                  margin-left: 5px;
                  width: 36px;
                  height: 28px;
                }
              }
            }
          }
        }
      }
      .content-bottom-layout {
        position: absolute;
        bottom: -20px;
        left: 0;
        width: 100%;
        height: 106px;
        background-image: url("@/assets/wordTest/bottom.png");
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        .right {
          flex: 1;
          height: 100%;
          box-sizing: border-box;
          display: flex;
          .progress {
            display: flex;
            height: 100%;
            flex: 1;
            justify-content: center;
            .progress-child {
              display: flex;
              align-items: center;
            }
            &:first-child {
              .step {
                & > div:first-child {
                  margin-left: 8px;
                }
              }
            }
            .step {
              & > div:first-child {
                display: flex;
                align-items: center;
              }
              .no-start {
                font-size: 12px;
                color: #888888;
                transform: translate(16px, 5px);
              }
              .step-text-box {
                width: 48px;
                height: 21px;
                color: #fff;
                font-size: 12px;
                background: #c8d0e2;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translate(10px, 5px);
                &.active {
                  background: linear-gradient(90deg, #38d9a7 0%, #1cc793 100%);
                }
              }
              .step-text {
                font-size: 12px;
                color: #333333;
                margin-top: 6px;
                transform: translateX(-10px);
                .pass {
                  color: #a382ff;
                }
              }
              .next-icon {
                width: 24px;
                height: 20px;
                margin: 0 10px 0 30px;
              }
              img {
                width: 49px;
                height: 49px;
              }
            }
          }
          .bottom-btn-wrap {
            padding-right: 10px;
            box-sizing: border-box;
            width: 255px;
            display: flex;
            align-items: center;
            justify-content: center;
            & > div {
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .bottom-btn {
              &.funnel {
                width: 185px;
                background: linear-gradient(90deg, #bba3fe 0%, #a07dff 100%);
                box-shadow: inset 0px 3px 10px 1px rgba(255, 255, 255, 0.26);
              }
              width: 110px;
              height: 41px;
              background: linear-gradient(90deg, #75c1fc 0%, #85a7ff 100%);
              box-shadow: inset 0px 3px 10px 1px rgba(255, 255, 255, 0.3);
              border-radius: 20px;
              font-weight: bold;
              font-size: 15px;
              color: #ffffff;
              text-align: center;
              line-height: 41px;
              &.free {
                margin-left: 10px;
                background: linear-gradient(90deg, #bba3fe 0%, #a07dff 100%);
              }
            }
          }
        }
        .left {
          width: 322px;
          height: 100%;
          background-image: url("@/assets/wordTest/bottom-l.png");
          background-repeat: no-repeat;
          background-size: cover;
          display: flex;
          padding-left: 120px;
          .words-info {
            flex: 1;
            display: flex;
            align-items: center;
            flex-direction: column;
            color: #ffffff;
            .words-info-item {
              &:first-child {
                width: 108px;
                height: 23px;
                background: linear-gradient(
                  90deg,
                  rgba(255, 255, 255, 0) 0%,
                  rgba(170, 255, 164, 0.2) 50%,
                  rgba(255, 255, 255, 0) 100%
                );
                font-size: 11px;
                text-align: center;
                line-height: 23px;
                margin: 14px 20px 6px 0;
              }
              &:last-child {
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .words-info-item-content {
                font-size: 13px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                &:last-child {
                  margin-left: 30px;
                  margin-right: 30px;
                }
                span {
                  font-weight: bold;
                  font-size: 21px;
                }
              }
            }
          }
          .ip-content {
            position: relative;
            margin-left: 20px;
            height: 100%;
            .ip {
              width: 120px;
              height: 120px;
              position: absolute;
              z-index: 2;
              left: -120px;
              bottom: 30px;
            }
            .ip-text {
              width: 120px;
              height: 28px;
              text-align: center;
              line-height: 28px;
              border-radius: 20px;
              position: absolute;
              left: -120px;
              bottom: 20px;
              font-weight: bold;
              font-size: 13px;
              color: #fff;
              z-index: 3;
              background: linear-gradient(
                180deg,
                rgba(142, 199, 255, 1) 0%,
                rgba(116, 157, 252, 1) 100%
              );
            }
          }
        }
      }
    }
  }
}
</style>
